'use client';

import { Switch as HeadlessSwitch } from '@headlessui/react';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import React, { useState } from 'react';

function Switch(props) {
  const { label, checked, value, onChange, className, error, disabled = false, ...rest } = props;
  const [enabled, setEnabled] = useState(checked || value || false);
  const hasError = !!error;

  const onToggle = () => {
    const state = !enabled;
    setEnabled(state);
    onChange(state);
  };

  return (
    <HeadlessSwitch.Group as="div" className="flex items-center gap-3">
      <HeadlessSwitch
        {...rest}
        checked={enabled}
        disabled={disabled}
        onChange={onToggle}
        className={cx(
          enabled ? 'bg-primary' : 'bg-text-disabled',
          disabled ? 'bg-gray-300 cursor-not-allowed': '',
          'h-[28px] w-[54px] relative inline-flex cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75'
        )}>
        <span
          disabled={disabled}
          aria-hidden="true"
          className={cx(
            enabled ? 'translate-x-[26px]' : 'translate-x-0',
            disabled ? 'bg-gray-300 cursor-not-allowed': '',
            'h-[24px] w-[24px] pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out'
          )}
        />
      </HeadlessSwitch>
      <HeadlessSwitch.Label>
        <Typography variant="body1" color={hasError ? 'error' : 'textPrimary'}>
          {label}
        </Typography>
      </HeadlessSwitch.Label>
    </HeadlessSwitch.Group>
  );
}

export default Switch;
